import React from "react";
import MuiIconButton, { IconButtonProps } from "@material-ui/core/IconButton";

type Props = IconButtonProps & {
  classes?: any;
  id: string;
};

export const IconButton = (props: Props) => {
  return (
    <MuiIconButton {...props} id={props.id} data-test-control={props.id} />
  );
};
